(function ($) {
    $.fn.productFormBuilder = function (options) {
        const settings = $.extend({
            fields: [],
            image_url: null,
            ajaxRemoveOptionUrl: null
        }, options);

        let fieldIndex = 0;
        const container = this;

        // Helper: Update JSON and log
        function getJSON() {
            // console.log('Updated JSON:', JSON.stringify(settings.fields, null, 2));
            return JSON.stringify(settings.fields, null, 2);
        }

        function renderField(field = {}) {
            const index = fieldIndex++;
            if (!settings.fields[index]) settings.fields[index] = field;

            const optionsHtml = (field.options || []).map((opt, optIndex) => `
                <div class="option-item row g-2 mb-2 align-items-center">
                    <div class="col">
                        <input type="text" class="form-control form-control-sm option-label" placeholder="Label" data-field="${index}" data-option="${optIndex}" value="${opt.label}" required>
                    </div>
                    <div class="col">
                        <input type="text" class="form-control form-control-sm option-value" placeholder="Value" data-field="${index}" data-option="${optIndex}" value="${opt.value}" required>
                    </div>
                    <div class="col">
                        <input type="text" class="form-control form-control-sm image_autocomplete option-image" placeholder="Image URL" data-field="${index}" data-option="${optIndex}" value="${opt.image_url || ''}">
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-sm btn-danger remove-option" data-field="${index}" data-option="${optIndex}">&times;</button>
                    </div>
                </div>
            `).join('');

            const html = `
                <div class="card mb-2 p-2 field-card" data-index="${index}">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong>Field ${index + 1}</strong>
                        <div>
                            <span class="handle btn btn-sm btn-light">&#x2630;</span>
                            <span type="button" class="btn btn-sm btn-danger remove-field" data-field="${index}" title="Remove Field">&times;</span>
                        </div>
                    </div>

                    <div class="mb-1">
                        <select class="form-control form-select-sm field-type" data-field="${index}">
                            ${['text', 'select', 'increment_select', 'radio', 'checkbox', 'image_checkbox'].map(type => `
                                <option value="${type}" ${field.type === type ? 'selected' : ''}>${type}</option>
                            `).join('')}
                        </select>
                    </div>

                    <div class="row">
                        <div class="mb-1 col-4">
                            <label class="form-label small mb-0">Field Label</label>
                            <input type="text" class="form-control form-control-sm field-label" data-field="${index}" value="${field.label || ''}" required>
                        </div>
                        <div class="mb-1 col-4">
                            <label class="form-label small mb-0">Field Name</label>
                            <input type="text" class="form-control form-control-sm field-name" data-field="${index}" value="${field.field_name || ''}" required>
                        </div>
                        <div class="mb-1 col-4">
                            <label class="form-label small mb-0">Increment Select Prepend</label>
                            <input type="text" class="form-control form-control-sm field-prepend" data-field="${index}" value="${field.prepend || ''}">
                        </div>
                    </div>

                    <div class="row mb-1">
                        <div class="col-4">
                            <label class="form-label small mb-0">Default Value</label>
                            <input type="text" class="form-control form-control-sm field-default" data-field="${index}" value="${field.default_value || ''}">
                        </div>
                        <div class="col-4">
                            <label class="form-label small mb-0">Min Value</label>
                            <input type="number" class="form-control form-control-sm field-min" data-field="${index}" value="${field.min || ''}">
                        </div>
                        <div class="col-4">
                            <label class="form-label small mb-0">Max Value</label>
                            <input type="number" class="form-control form-control-sm field-max" data-field="${index}" value="${field.max || ''}">
                        </div>
                    </div>

                    <div class="options-container" id="options-${index}" style="${['select','increment_select','radio','checkbox','image_checkbox'].includes(field.type) ? '' : 'display:none;'}">
                        <label class="form-label mt-1 mb-1">Options</label>
                        <div class="option-list">${optionsHtml}</div>
                        <button type="button" class="btn btn-sm btn-outline-secondary add-option" data-field="${index}">+ Add Option</button>
                    </div>
                </div>
            `;

            container.append(html);
        }

        // Update JSON on field input/select changes
        container.on('input change', '.field-label, .field-name, .field-prepend, .field-default, .field-min, .field-max', function() {
            const index = $(this).data('field');
            let val = $(this).val();
                // Prevent spaces in field-name
            if ($(this).hasClass('field-name')) {
                val = val.replace(/\s+/g, '_'); // removes all spaces
                $(this).val(val); // update input value to remove spaces
                settings.fields[index].field_name = val;
            }
            else if ($(this).hasClass('field-label')) settings.fields[index].label = val;
            else if ($(this).hasClass('field-prepend')) settings.fields[index].prepend = val;
            else if ($(this).hasClass('field-default')) settings.fields[index].default_value = val;
            else if ($(this).hasClass('field-min')) settings.fields[index].min = val;
            else if ($(this).hasClass('field-max')) settings.fields[index].max = val;

            getJSON();
        });

        container.on('change', '.field-type', function () {
            const index = $(this).data('field');
            const selected = $(this).val();
            settings.fields[index].type = selected;
            $(`#options-${index}`).toggle(['select', 'increment_select', 'radio', 'checkbox', 'image_checkbox'].includes(selected));
            getJSON();
        });

        // Options input changes
        container.on('input change', '.option-label, .option-value, .option-image', function() {
            const fieldIdx = $(this).data('field');
            const optIdx = $(this).data('option');
            if (!settings.fields[fieldIdx].options) settings.fields[fieldIdx].options = [];
            if (!settings.fields[fieldIdx].options[optIdx]) settings.fields[fieldIdx].options[optIdx] = { label:'', value:'', image_url:'' };

            if ($(this).hasClass('option-label')) settings.fields[fieldIdx].options[optIdx].label = $(this).val();
            else if ($(this).hasClass('option-value')) settings.fields[fieldIdx].options[optIdx].value = $(this).val();
            else if ($(this).hasClass('option-image')) settings.fields[fieldIdx].options[optIdx].image_url = $(this).val();

            getJSON();
        });

        // Add/remove field or option
        container.on('click', '.remove-field', function () {
            const index = $(this).data('field');

            // Remove from array
            settings.fields.splice(index, 1);

            // Remove from DOM
            $(this).closest('.field-card').remove();

            // Re-index remaining fields in DOM
            container.find('.field-card').each(function(newIndex) {
                $(this).attr('data-index', newIndex);
                $(this).find('[data-field]').each(function() {
                    $(this).attr('data-field', newIndex);
                });
                $(this).find('.option-item [data-field]').each(function() {
                    $(this).attr('data-field', newIndex);
                });
            });

            getJSON();
        });

        container.on('click', '.add-option', function () {
            const fieldIdx = $(this).data('field');

            // Ensure options array exists
            if (!settings.fields[fieldIdx].options) settings.fields[fieldIdx].options = [];

            // New option object
            const newOption = { label: '', value: '', image_url: '' };
            const optIdx = settings.fields[fieldIdx].options.length;
            settings.fields[fieldIdx].options.push(newOption);

            // Create HTML for new option
            const optHtml = `
                <div class="option-item row g-2 mb-2 align-items-center">
                    <div class="col">
                        <input type="text" class="form-control form-control-sm option-label" placeholder="Label" data-field="${fieldIdx}" data-option="${optIdx}" required>
                    </div>
                    <div class="col">
                        <input type="text" class="form-control form-control-sm option-value" placeholder="Value" data-field="${fieldIdx}" data-option="${optIdx}" required>
                    </div>
                    <div class="col">
                        <input type="text" class="form-control form-control-sm image_autocomplete option-image" placeholder="Image URL" data-field="${fieldIdx}" data-option="${optIdx}">
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-sm btn-danger remove-option" data-field="${fieldIdx}" data-option="${optIdx}">&times;</button>
                    </div>
                </div>
            `;

            // Append to option-list
            $(`#options-${fieldIdx} .option-list`).append(optHtml);

            // Log updated JSON
            getJSON();
        });

        container.on('click', '.remove-option', function () {
            const fieldIdx = $(this).data('field');
            const optIdx = $(this).data('option');
            var self = this;

            beautify.sweetConfirm('Delete option?', 'Click ok to proceed!', function(confirm) {
                if (!confirm) return;

                // Get the option ID
                var removedOptionId = settings.fields[fieldIdx].options[optIdx].id;

                // Function to remove locally
                function removeLocalOption() {
                    settings.fields[fieldIdx].options.splice(optIdx, 1);

                    $(self).closest('.option-item').remove();

                    // Re-index remaining options
                    $(`#options-${fieldIdx} .option-item`).each(function(newOptIdx) {
                        $(this).find('[data-option]').each(function() {
                            $(this).attr('data-option', newOptIdx);
                        });
                    });

                    getJSON();
                }

                if (removedOptionId === undefined) {
                    // Option not saved, just remove locally
                    removeLocalOption();
                    beautify.notification('Option removed locally', 'success');
                } else {
                    // Option exists on server, call AJAX
                    ajaxRemoveOption(removedOptionId).then(function(response) {
                        if (response.status === 'success') {
                            removeLocalOption();
                            beautify.notification(response.message, 'success');
                        } else {
                            beautify.notification(response.message ?? 'Unable to delete the option', 'error');
                        }
                    });
                }
            });

        });

        function ajaxRemoveOption(optionId) {
            var csrf = $("meta[name=csrf-token]");
            return $.ajax({
                url: settings.ajaxRemoveOptionUrl.replace(':id', optionId),
                method: 'DELETE',
                data: { _token: csrf.attr('content') }
            }).then(function(response) {
                // return the whole response object
                return response;
            })
            .catch(function() {
                // optionally return a default/failure object
                return { status: 'error' };
            });
        }




        // Sortable updates
        container.sortable({
            handle: '.handle',
            items: '.field-card',
            placeholder: 'sortable-placeholder',
            forcePlaceholderSize: true,
            tolerance: 'pointer',
            update: function() {
                const newFields = [];
                container.find('.field-card').each(function() {
                    const idx = $(this).data('index');
                    newFields.push(settings.fields[idx]);
                });
                settings.fields = newFields;
                getJSON();
            }
        });

        function attachAutocomplete(el) {
            $(el).autocomplete({
                source: function(request, response) {
                    $.ajax({
                        url: settings.image_url,
                        data: { query: request.term },
                        success: function(data) {
                            // data must be array of {label, value, thumbnail}
                            response(data);
                        }
                    });
                },
                minLength: 1,
                select: function(event, ui) {
                    $(this).val(ui.item.value);
                    return false;
                }
            }).autocomplete("instance")._renderItem = function(ul, item) {
                const $li = $("<li>");
                const $wrapper = $("<div>").addClass("ui-menu-item-wrapper");
                $wrapper.append(`<img src="${item.url}" alt="">`);
                $wrapper.append($("<span>").text(item.label || item.value));
                $li.append($wrapper);
                return $li.appendTo(ul);
            };
        }

        // Attach when input gets focus (works for dynamic elements)
        container.on("focus", ".image_autocomplete", function () {
            console.log("Input focused");
            attachAutocomplete(this);
        });

        this.addField = () => renderField();
        this.getJSON = () => getJSON();
        settings.fields.forEach(renderField);

        return this;
    };
}(jQuery));
